import React, { Component } from 'react'
import { StaticQuery, graphql } from "gatsby"
import ContentFront from '../../components/Layout/ContentFront'

class Articles extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            allNodeArticle(filter: {promote: {eq: true}}, limit: 2, sort: {fields: created, order: DESC}) {
              edges {
                node {
                  id
                  title
                  field_teaser
                  promote
                  displayDate: created(formatString: "MM/DD/Y")
                  path {
                    alias
                  }
                  relationships {
                    featuredImage: field_image {
                      localFile {
                        childImageSharp {
                          fluid(maxWidth: 125, quality: 100) {
                            aspectRatio
                            ...GatsbyImageSharpFluid_withWebp
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `}

        render={data => (
          <section>
            {data.allNodeArticle.edges.map(article => (
              <>
                <ContentFront data={article.node} title="article" link="/articles"/>
              </>
            ))}
          </section>
        )}
      />
    )
  }
}

export default Articles